(function () {'use strict';}());

angular.module('app')
  .controller('AppController', function ($scope,$timeout,$window,$rootScope,AppService, AnalyticsService) {
  	var trace = angular.trace;

    var requestedPage = angular.GET.page;
    var requestedActivity = angular.GET.activity;
    var requestedMute = angular.GET.mute === "true";

    $scope.PAGE_SPLASH = -1;
  	$scope.PAGE_LANDING = 0;
    $scope.PAGE_THEME_SELECTION = 1;
    $scope.PAGE_THEME_POST =  2;
    $scope.PAGE_GRAPHIC_PANEL = 3;
  	$scope.PAGE_MAP = 4;
    $scope.PAGE_MAP_POST = 5;
    $scope.PAGE_ARTIFACT_COLLECTION = 6;
    $scope.PAGE_MINIGAME_PRE = 6.5;
  	$scope.PAGE_MINIGAME = 7;
    $scope.PAGE_COMPLETION_PRE = 8;
    $scope.PAGE_LOSE_PRE = 9;
    $scope.PAGE_COMPLETION = 10;
    $scope.PAGE_LOSE = 11;
    $scope.PAGE_NOWHERE = 12;
    $scope.PAGE_RANK = 13;

    var device = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));


  	//These constants correspond to the minigame json file names
  	$scope.MINIGAME_QA = "qa";
  	$scope.MINIGAME_FACTS = "fact-opinion";
    $scope.MINIGAME_CAUSE_EFFECT = "cause-effect";
    $scope.MINIGAME_MEMORY = "psychic-memory";

  	$scope.currentPageIndex = __STANDALONE__ ? $scope.PAGE_THEME_SELECTION : -1;
  	$scope.currentMinigame = null;
    $scope.currentFeedback = null;
    $scope.currentArtifact = null;
    $scope.modalCallback = null;
    $scope.ready = false;

    $scope.hoursRemaining = 48;

    $scope.containerClasses = {rendered:false};
    $scope.currentScale = 1;
    $scope.currentOffsetX = 0;
    $scope.currentOffsetY = 0;
    $scope.preventScale = false;

    $scope.locationsComplete = 0;

    $scope.mapCache = {};


    AppService.loadContent().then(initialize);


    $scope.setMiniGame = function(pageID){
        $scope.setCurrentAdventure("early-georgia");
        $scope.setCurrentPage(pageID);


    };

    $scope.setCurrentAdventureComplete = function(){
       $scope.currentAdventure.complete = true;
       $scope.currentAdventure.started = true;
    };

    $scope.setCurrentPage = function(page,reset){
      $scope.preventScale = false;
    	$scope.currentPageIndex = page;
      $scope.containerClasses.shortPage = page === $scope.PAGE_MAP; 

      trace("Setting",page);

      $rootScope.stopBackgroundAudio();
      if($scope.currentPageIndex === $scope.PAGE_MINIGAME) $rootScope.$emit("audio","Start_Mini-Game");
      $scope.$broadcast("currentPageIndex",$scope.currentPageIndex);
    };

    $scope.setScalingPrevention = function(value){
      $scope.preventScale = value;
    };

    $scope.getPagePosition = function(page){
    	if(page < $scope.currentPageIndex) return "left";
    	if(page > $scope.currentPageIndex) return "right";
    	return "center";
    };

    $scope.setCurrentAdventure = function(id,playSFX){
      $scope.locationsComplete = 0;
      $scope.currentAdventure = AppService.adventures[id];
      $scope.hoursRemaining = 48;

      var periods = $scope.currentAdventure.periods;
      var locations = $scope.currentAdventure.locations;
      var i,count,period,location;
      for(i = 0, count = periods.length; i < count; i ++){
          period = periods[i];
          period.artifacts = [];
      }
      for(i = 0, count = locations.length; i < count; i ++){
          location = locations[i];
          if(location.artifact) location.artifact.complete = false;
          delete location.complete;
          delete location.correct;
      }
    };

    $scope.updateTelepathy = function(value){
      $rootScope.$broadcast("telepathy",value);
    };
    $scope.updatePoints= function(value){
      $rootScope.$broadcast("points",value);
    };

    $scope.drawDownHours = function(amount,final){
      if(!amount) amount = 2;
      //amount = 24;
      $scope.hoursRemaining -= amount;
      if($scope.hoursRemaining < 0) $scope.hoursRemaining = 0;
    };
    $scope.locationComplete = function(location){
      var count = $scope.currentAdventure.locations.length;
      var complete = 0;
      for(var i = 0; i< count; i++){
        var loc = $scope.currentAdventure.locations[i];
        if(loc.complete) complete++;
      }
      $scope.locationsComplete = complete;
      $scope.$broadcast("locationComplete",$scope.currentLocation);
    };

    $scope.setCurrentLocation = function(location){
      $scope.currentLocation = location;
      $scope.clearCurrentMinigame();
      $scope.$broadcast("locationChange",location);
      if(location && location.correct ===  true) $timeout(function(){$scope.currentMinigame = $scope.currentLocation["mini-game"];},0);
    };

    $scope.clearCurrentMinigame = function(){
        $scope.currentMinigame = null;
    };

    $scope.setCurrentFeedback = function(value,callback,reset){
      $scope.modalCallback = callback;
      $scope.currentFeedback = value;
      $scope.resetCallback = reset;
    };

    $scope.setCurrentArtifact = function(value,callback){
      $scope.modalCallback = callback;
      $scope.currentArtifact = value;
      $scope.preventScale = false;
    };

    $scope.getModalState = function(type){
      switch(type){
        case "artifact":
          return $scope.currentArtifact !== null ? "active":"";
        case "feedback":
           return $scope.currentFeedback !== null ? "active":"";
        default:
          return null;
      }
    };

    $scope.dismissModal = function(reset){
      if($scope.currentPageIndex === $scope.PAGE_ARTIFACT_COLLECTION) $scope.preventScale = true;
      if(reset && $scope.resetCallback){
        $timeout($scope.resetCallback.resolve,0);
        $scope.lastArtifact = $scope.currentArtifact;
        $scope.currentArtifact = $scope.currentFeedback = $scope.modalCallback = null;
        return;
      }
      if($scope.modalCallback) $timeout($scope.modalCallback.resolve,0);
      if(!$scope.modalCallback.resolve) $timeout($scope.modalCallback,0);
      $scope.lastArtifact = $scope.currentArtifact;
      $scope.currentArtifact = $scope.currentFeedback = $scope.modalCallback = null;


    };

    $scope.getPageValue = function(value){
      return $scope[value];
    };

    $scope.reset = function(){
      $scope.hoursRemaining = 48;

      var periods = $scope.currentAdventure.periods;
      var locations = $scope.currentAdventure.locations;
      var i,count,period,location;
      for(i = 0, count = periods.length; i < count; i ++){
          period = periods[i];
          period.artifacts = [];
      }
      for(i = 0, count = locations.length; i < count; i ++){
          location = locations[i];
          if(location.artifact) location.artifact.complete = false;
          delete location.complete;
          delete location.correct;
      }

      $scope.$broadcast("reset");
      $scope.mapCache = {};
      $scope.currentAdventure = null;
      $scope.setCurrentPage($scope.PAGE_THEME_SELECTION);
      $scope.locationsComplete = 0;
      //$rootScope.$emit("audio","Open_Envelope");
    };

    $scope.help = function(){
      $scope.currentHelp = fetchPageName($scope.currentPageIndex);
    };
    $scope.dismissHelp = function(){
      $scope.currentHelp = false;
    };

    $scope.setGeocacheCallback = function(value){
      $scope.geocache = true;
      $scope.geocacheCallback = value;
    };

    $scope.dismissGeocache = function(){
      $scope.geocache = false;
      if($scope.geocacheCallback) $scope.geocacheCallback();
      $scope.geocacheCallback = null;
    };


    if(device){
         $(window).on("orientationchange",function(){
            $scope.$apply(function(){
              $timeout(function(){onWindowResize();},200);//MD added a slight delay so that window.innerHeight/width gets updated on Samsung tablet
              //onWindowResize();
            });
         });

         $("body").on("gesturestart",function(e){
          if(e.scale !== 1) e.preventDefault();
         });
    }
    else{
     $(window).resize(function(){
          $scope.$apply(function(){
            onWindowResize();
          });
        }); 
    }



    function fetchPageName(index){
      if(index === $scope.PAGE_MINIGAME) return $scope.currentMinigame.type;

      for(var prop in $scope){
        var reg = /^PAGE_(.*?)$/gim;
        var result = reg.exec(prop);
        if(!result) continue;
        if($scope[prop] !== index) continue;
        return result[1].toLowerCase();
      }
      return "";
    }

    function onWindowResize(event){

      var scaleX = window.innerWidth/1920;
      var scaleY = window.innerHeight/1080;
      var scale = Math.min(scaleX,scaleY,1);
      var calculatedWidth = 1920 * scale;
      var calculatedHeight = 1080 * scale;
      trace("resizing -- w:"+window.innerWidth + " h:" + window.innerHeight,event,"-------");
      $scope.currentScale = scale;



      //trace("resizing window");

      if(scaleY === scale)
      {
        $scope.containerClasses.adjustX = true;
        $scope.containerClasses.adjustY = false;
        $scope.currentOffsetY = 0;
        $scope.currentOffsetX = Math.max(0,(window.innerWidth-calculatedWidth)/2/scale);
      }
      else if(scaleX === scale)
      {
        $scope.containerClasses.adjustY = true;
        $scope.containerClasses.adjustX = false;
        $scope.currentOffsetX = 0;
        $scope.currentOffsetY = Math.max(0,(window.innerHeight-calculatedHeight)/2/scale);
      }
      else{
        $scope.containerClasses.adjustX = false;
        $scope.containerClasses.adjustY = false;
        $scope.currentOffsetX = $scope.currentOffsetY = 0;
      }
    }
    function checkBrowser(){
      var browser = BrowserDetect.browser;
      var version = BrowserDetect.version;

      switch(browser){
        case "Safari":
          if(version >= 8) return;
        break;
        case "Chrome":
          if(version >= 40) return;
        break;
        case "Firefox":
          if(version >= 35) return;
        break;
        case "Explorer":
          if(version >= 11) return;
        break;
        case "Edge":
          if(version) return;
        break;
        default:
      }
      alert("You may be using an unsupported browser. Some aspects of the game may not work as expected");
    }
    function initialize(data){
      $timeout(function(){
        onWindowResize();
        checkBrowser();
        $scope.containerClasses.rendered = true;
        $scope.setCurrentAdventure("early-georgia");
        $scope.$broadcast("currentPageIndex",$scope.currentPageIndex);
        if(requestedPage) $scope.currentPageIndex = $scope[requestedPage];


        $scope.iOS8 = BrowserDetect.browser === "Safari" && BrowserDetect.version === 8;
        $scope.containerClasses.ff = BrowserDetect.browser === "Firefox";
        $scope.containerClasses.ie = BrowserDetect.browser.match(/Edge/gim) || BrowserDetect.browser.match(/Explorer/gim);

        $rootScope.$emit("audioLoad");

        if(requestedMute) $rootScope.audioOn = false;

        if(requestedActivity !== undefined){
           $timeout(function(){
            //1 = QA / 2 = Memory / 0 = CE / 7 = facts
            var game =  requestedActivity;
            $scope.currentAdventure.locations[game].correct = true;
            trace("setting current location",$scope.currentAdventure.locations);
            $scope.setCurrentLocation($scope.currentAdventure.locations[game]);
            $scope.setCurrentPage($scope.PAGE_MINIGAME);
            //$scope.setCurrentPage($scope.PAGE_ARTIFACT_COLLECTION);
        },10);  }
           else if($scope.currentPageIndex === $scope.PAGE_SPLASH) $rootScope.requestBackgroundAudio("Mandolin_Strummin_Fun");

        $scope.ready = true;
        $rootScope.$broadcast("ready","ready");
        
      },1000);

    }


  });
